import { SurfaceWaterIcon } from '../icons'

export default {
  id: 'surface',
  title: {
    en: 'Surface Water',
    ar: 'المياه السطحية'
  },
  description: {
    en: `<p>Surface water can be found on the surface of the Earth in bodies of water like rivers and streams and accounts for nearly 30% of Jordan’s total water supply.</p><p>Much of Jordan’s surface water, like the Jordan and Yarmouk rivers, are shared with neighboring countries.</p>`,
    ar: `<p>يمكن العثور على المياه السّطحيّة في المسطحات المائية مثل الأنهار والجداول، وتشكّل المياه السّطحيّة ما يُقارب 30% من مياه التزويد في الأردن.</p><p>يتشارك الأردن الكثير من موارد مياهِه السّطحيّة - مثل نهري الأردن واليرموك - مع البلدان المجاورة.</p>`
  },
  Icon: SurfaceWaterIcon,
  entries: [
    {
      id: 'taberias',
      type: 'lake',
      title: { en: 'taberias', ar: 'بحيرة طبيرة' },
      area: '166',
      elevation: '-212.1',
      maxDepth: '43'
    },
    {
      id: 'deadsea',
      title: { en: 'dead sea', ar: 'البحر الميت' },
      area: '605',
      type: 'lake',
      elevation: '−430.5',
      maxDepth: '298'
    },
    {
      id: 'jordan-river',
      title: { en: 'jordan river', ar: 'نهر الأردن' },
      length: '251',
      source: { en: 'Lake Tiberias', ar: 'بحيرة طبيرة' },
      mouth: { en: 'dead sea', ar: 'البحر الميت' },
      type: 'river',
      flow: '16'
    },
    {
      id: 'yarmouk-river',
      title: { en: 'Yarmouk River', ar: 'نهر اليرموك' },
      length: '70',
      source: { en: 'Mount Hermon', ar: 'بحيرة طبيرة' },
      mouth: { en: 'jordan river', ar: 'نهر الأردن' },
      type: 'river',
      flow: '14.5'
    },
    {
      id: 'zarqa-river',
      title: { en: 'Zarqa River', ar: 'نهر الزرقاء' },
      length: '65',
      source: { en: 'Ayn Ghazal', ar: 'بحيرة طبيرة' },
      mouth: { en: 'jordan river', ar: 'نهر الأردن' },
      type: 'river',
      flow: '8'
    }
  ]
}
